import { render, staticRenderFns } from "./UpsellModal.vue?vue&type=template&id=56e134c6&"
import script from "./UpsellModal.vue?vue&type=script&lang=js&"
export * from "./UpsellModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports